import { Component, OnInit } from '@angular/core';
import { MultiSelect } from 'primeng/multiselect';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { REQUEST_STEPS } from '../../../enum-request-steps';
import { MarketPlaceQuoteRequestService } from '../../../../../../services/market-place-quote-request-service/market-place-quote-request.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoginService } from 'src/app/services/login-service/login.service';
import { draftQuoteRequest } from 'src/app/services/market-place-quote-request-service/draft-quote-request.service';
import { MixpanelService } from '../../../../../../services/mixpanel-service/mixpanel.service';
@Component({
  selector: 'app-pressure-cart-options',
  templateUrl: './pressure-cart-options.component.html',
  styleUrls: ['../../mechanical-options.component.scss'],
})
export class PressureCartOptionsComponent implements OnInit {
  pressureCartOptions: any;
  objPressureCartOptions: any;
  private config: any = null;

  addinginteriorPrep = false;
  newinteriorPrepText = '';

  addingNitrogenPSI = false;
  newNitrogenPSIText = '';

  addingOxygenContent = false;
  newOxygenContentText = '';

  otherSelected = false;

  otherSelectedoRing = false;

  displayInteriorPrepHelp = false;

  flangeFilterValue = '';
  newFlangeText = '';

  oringFilterValue = '';
  newOringText = '';

  quoteRequest: any;

  pressureCartForm = new FormGroup({
    'device-settings': new FormControl(null, [Validators.required]),
    'need-thermowell': new FormControl(null, [Validators.required]),
    'need-sample-line': new FormControl(null, [Validators.required]),
    'flange-gasket': new FormControl(null, [Validators.required]),
    'o-ring-required': new FormControl(null, [Validators.required]),
    'interior-prep': new FormControl(null, [Validators.required]),
    'oxygen-content': new FormControl(null, [Validators.required]),
    'nitrogen-psi': new FormControl(null, [Validators.required]),
    selected: new FormControl(true),
  });

  constructor(
    private quoteRequestService: MarketPlaceQuoteRequestService,
    private httpClient: HttpClient,
    private draftQuoteService: draftQuoteRequest,
    private mixpanelService: MixpanelService,
    private loginService: LoginService
  ) {
    const strConfig = localStorage.getItem('config-service');
    if (strConfig) {
      this.config = JSON.parse(strConfig);
    }

    this.quoteRequestService.quoteRequest$.subscribe((value) => {
      this.quoteRequest = value;
      this.objPressureCartOptions =
        value['mechanical-options']['pressure-tank'];
      this.getOptions();
    });

    this.pressureCartForm.valueChanges.subscribe(() => {
      this.quoteRequest['mechanical-options']['pressure-tank'] =
        this.createSubmittedObj();
    });
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.subscribeToFormControlChanges();
  }

  private subscribeToFormControlChanges(): void {
    const formControls = this.pressureCartForm.controls;

    Object.keys(formControls).forEach((controlName) => {
      formControls[controlName].valueChanges.subscribe((value) => {
        if (value) {
          this.trackFormControlChange(controlName, value);
        }
      });
    });
  }

  private trackFormControlChange(controlName: string, value: any): void {
    let eventName = '';
    let eventDisplayName = '';
    let eventDefinition = '';
    let parentEvent = '';
    let subParentEvent = '';

    switch (controlName) {
      case 'lining-requirements':
        eventName = 'Magnetic gauging device settings';
        eventDisplayName = value;
        eventDefinition = `User changed the value of lining requirements to '${value}'`;
        parentEvent = 'Begin Quote';
        subParentEvent = 'Mechanical Options';
        break;
      case 'need-thermowell':
        eventName = 'Do you need a thermowell?';
        eventDisplayName = value;
        eventDefinition = `User selected '${value}' for thermowell requirement`;
        parentEvent = 'Fittings & Accessories';
        subParentEvent = 'Device Settings';
        break;
      case 'need-sample-line':
        eventName = ' Do you need a sample line?';
        eventDisplayName = value;
        eventDefinition = `User selected '${value}' for sample line requirement`;
        parentEvent = 'Fittings & Accessories';
        subParentEvent = 'Device Settings';
        break;
      case 'flange-gasket':
        eventName = 'What type of flange gasket is needed?';
        eventDisplayName = value.map((item: any) => item.name).join(', ');
        eventDefinition = `User selected '${value}' for flange gasket type`;
        parentEvent = 'Gasket & O-Rings';
        subParentEvent = 'Flange Gasket';
        break;
      case 'o-ring-required':
        eventName = 'What o-ring is required?';
        eventDisplayName = value.map((item: any) => item.name).join(', ');
        eventDefinition = `User selected '${value}' for o-ring type`;
        parentEvent = 'Gasket & O-Rings';
        subParentEvent = 'O-Ring';
        break;
      case 'interior-prep':
        eventName = 'Interior Prep';
        eventDisplayName = value;
        eventDefinition = `User selected '${value}' for interior prep`;
        parentEvent = 'Interior Prep';
        subParentEvent = '';
        break;
      case 'oxygen-content':
        eventName = 'Oxygen Content';
        eventDisplayName = value;
        eventDefinition = `User selected '${value}' for oxygen content`;
        parentEvent = 'Purge & Pad';
        subParentEvent = '';
        break;
      case 'nitrogen-psi':
        eventName = 'Nitrogen PSI';
        eventDisplayName = value;
        eventDefinition = `User selected '${value}' for nitrogen PSI`;
        parentEvent = 'Purge & Pad';
        subParentEvent = '';
        break;
    }

    this.mixpanelService.track({
      eventName,
      eventDisplayName,
      kpi: 'User Engagement',
      trigger: 'On Input Change',
      eventDefinition,
      propertyType: 'Event Property',
      propertyDefinition: controlName,
      additionalProperties: {
        newValue: value,
        parentEvent,
        subParentEvent,
      },
    });
  }

  getOptions(): any {
    const token = this.loginService.getSessionToken();
    if (token === null) this.loginService.signout();

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    this.httpClient
      .post(this.config.leaseMechOptionsURL, {}, { headers: headers })
      .subscribe((data: any) => {
        this.pressureCartOptions = data['mechanical-options']['pressure-tank'];
        this.setPressureForm();
      });
  }

  setPressureForm() {
    this.pressureCartForm.patchValue(this.objPressureCartOptions);

    if (this.pressureCartForm.value['device-settings'] === '') {
      this.pressureCartForm
        .get('device-settings')
        ?.setValue(this.pressureCartOptions['device-settings'][0]);
    } else {
      const ds = this.pressureCartOptions['device-settings'].filter(
        (item: any) =>
          item.id == this.objPressureCartOptions['device-settings'].id
      );
      this.pressureCartForm.get('device-settings')?.setValue(ds[0]);
    }

    if (this.pressureCartForm.value['need-thermowell'] === '') {
      this.pressureCartForm
        .get('need-thermowell')
        ?.setValue(this.pressureCartOptions['need-thermowell'][0]);
    } else {
      const vb = this.pressureCartOptions['need-thermowell'].filter(
        (item: any) =>
          item.id == this.objPressureCartOptions['need-thermowell'].id
      );
      this.pressureCartForm.get('need-thermowell')?.setValue(vb[0]);
    }

    if (this.pressureCartForm.value['need-sample-line'] === '') {
      this.pressureCartForm
        .get('need-sample-line')
        ?.setValue(this.pressureCartOptions['need-sample-line'][0]);
    } else {
      const vb = this.pressureCartOptions['need-sample-line'].filter(
        (item: any) =>
          item.id == this.objPressureCartOptions['need-sample-line'].id
      );
      this.pressureCartForm.get('need-sample-line')?.setValue(vb[0]);
    }

    if (this.pressureCartForm.value['flange-gasket'] === '') {
      this.pressureCartForm
        .get('flange-gasket')
        ?.setValue([this.pressureCartOptions['flange-gasket'][0]]);
    } else {
      // Add created 'Other' options
      this.pressureCartOptions['flange-gasket'] = this.createOptionsArray(
        this.pressureCartOptions['flange-gasket'],
        this.pressureCartForm.value['flange-gasket']
      );
    }

    if (this.pressureCartForm.value['o-ring-required'] === '') {
      this.pressureCartForm
        .get('o-ring-required')
        ?.setValue([this.pressureCartOptions['o-ring-required'][0]]);
    } else {
      // Add created 'Other' options
      this.pressureCartOptions['o-ring-required'] = this.createOptionsArray(
        this.pressureCartOptions['o-ring-required'],
        this.pressureCartForm.value['o-ring-required']
      );
    }

    if (this.pressureCartForm.value['interior-prep'] === '') {
      this.pressureCartForm
        .get('interior-prep')
        ?.setValue(this.pressureCartOptions['interior-prep'][0]);
    } else {
      const vb = this.pressureCartOptions['interior-prep'].filter(
        (item: any) =>
          item.id === this.objPressureCartOptions['interior-prep'].id
      );
      if (vb) {
        if (
          vb[0].id ===
          this.pressureCartOptions['interior-prep'][
            this.pressureCartOptions['interior-prep'].length - 1
          ].id
        ) {
          this.addinginteriorPrep = true;
          this.newinteriorPrepText =
            this.objPressureCartOptions['interior-prep'].name.match(
              /\((.*)\)/
            )[1];
          vb[0].name = this.objPressureCartOptions['interior-prep'].name;
          this.pressureCartForm.get('interior-prep')?.setValue(vb[0]);
        } else {
          this.pressureCartForm.get('interior-prep')?.setValue(vb[0]);
        }
      }
    }

    if (this.pressureCartForm.value['oxygen-content'] === '') {
      this.pressureCartForm
        .get('oxygen-content')
        ?.setValue(this.pressureCartOptions['oxygen-content'][0]);
    } else {
      const vb = this.pressureCartOptions['oxygen-content'].filter(
        (item: any) =>
          item.id == this.objPressureCartOptions['oxygen-content'].id
      );

      if (vb) {
        if (
          vb[0].id ===
          this.pressureCartOptions['oxygen-content'][
            this.pressureCartOptions['oxygen-content'].length - 1
          ].id
        ) {
          this.addingOxygenContent = true;
          this.newOxygenContentText =
            this.objPressureCartOptions['oxygen-content'].name.match(
              /\((.*)\)/
            )[1];
          vb[0].name = this.objPressureCartOptions['oxygen-content'].name;
          this.pressureCartForm.get('oxygen-content')?.setValue(vb[0]);
        } else {
          this.pressureCartForm.get('oxygen-content')?.setValue(vb[0]);
        }
      }
    }

    if (this.pressureCartForm.value['nitrogen-psi'] === '') {
      this.pressureCartForm
        .get('nitrogen-psi')
        ?.setValue(this.pressureCartOptions['nitrogen-psi'][0]);
    } else {
      const vb = this.pressureCartOptions['nitrogen-psi'].filter(
        (item: any) => item.id == this.objPressureCartOptions['nitrogen-psi'].id
      );

      if (vb) {
        if (
          vb[0].id ===
          this.pressureCartOptions['nitrogen-psi'][
            this.pressureCartOptions['nitrogen-psi'].length - 1
          ].id
        ) {
          this.addingNitrogenPSI = true;
          this.newNitrogenPSIText =
            this.objPressureCartOptions['nitrogen-psi'].name.match(
              /\((.*)\)/
            )[1];
          vb[0].name = this.objPressureCartOptions['nitrogen-psi'].name;
          this.pressureCartForm.get('nitrogen-psi')?.setValue(vb[0]);
        } else {
          this.pressureCartForm.get('nitrogen-psi')?.setValue(vb[0]);
        }
      }
    }
  }

  createSubmittedObj() {
    const obj = this.pressureCartForm.value;
    this.quoteRequest['mechanical-options']['isValid'] =
      this.pressureCartForm.valid;
    return obj;
  }

  checkFlangeValue(e: any, newFlangeInput: HTMLInputElement) {
    if (
      e.itemValue.id ===
      this.pressureCartOptions['flange-gasket'][
        this.pressureCartOptions['flange-gasket'].length - 1
      ].id
    ) {
      this.showAddFlange(newFlangeInput);
      this.otherSelected = true;
      this.pressureCartForm.controls['flange-gasket'].value.pop();
      setTimeout(() => {
        this.flangeFilterValue = '---11';
      });
    }

    if (e.itemValue.name.includes('Other (')) {
      const index = this.pressureCartOptions['flange-gasket'].indexOf(
        this.pressureCartOptions['flange-gasket'].find(
          (item: any) => item.id === e.itemValue.id
        )
      );

      if (index > 0) {
        this.pressureCartOptions['flange-gasket'].splice(index, 1);
      }
    }
  }

  checkOringValue(e: any, newOringInput: HTMLInputElement) {
    if (
      e.itemValue.id ===
      this.pressureCartOptions['o-ring-required'][
        this.pressureCartOptions['o-ring-required'].length - 1
      ].id
    ) {
      this.showAddOring(newOringInput);
      this.otherSelectedoRing = true;
      this.pressureCartForm.controls['o-ring-required'].value.pop();
      setTimeout(() => {
        this.oringFilterValue = '---11';
      });
    }

    if (e.itemValue.name.includes('Other (')) {
      const index = this.pressureCartOptions['o-ring-required'].indexOf(
        this.pressureCartOptions['o-ring-required'].find(
          (item: any) => item.id === e.itemValue.id
        )
      );

      if (index > 0) {
        this.pressureCartOptions['o-ring-required'].splice(index, 1);
      }
    }
  }

  showAddFlange(newFlangeInput: HTMLInputElement) {
    if (this.otherSelected) {
      setTimeout(() => {
        newFlangeInput.focus();
      }, 0);
    } else {
      this.flangeFilterValue = '';
    }
  }

  showAddOring(newOringInput: HTMLInputElement) {
    setTimeout(() => {
      newOringInput.focus();
    }, 0);
  }

  hideAddFlange(flangeGasketSelect: MultiSelect) {
    this.newFlangeText = '';
    if (flangeGasketSelect.filterValue === '---11') {
      setTimeout(() => {
        this.flangeFilterValue = '';
        flangeGasketSelect.filterValue = '';
      }, 0);
      this.focusFilterInput(flangeGasketSelect);
      this.otherSelected = false;
    } else {
      this.focusFilterInput(flangeGasketSelect);
      this.otherSelected = false;
    }
  }

  hideAddOring(oringSelect: MultiSelect) {
    this.newOringText = '';
    if (oringSelect.filterValue === '---11') {
      setTimeout(() => {
        this.oringFilterValue = '';
        oringSelect.filterValue = '';
      }, 0);
      this.focusFilterInput(oringSelect);
      this.otherSelectedoRing = false;
    } else {
      this.focusFilterInput(oringSelect);
      this.otherSelectedoRing = false;
    }
  }

  focusFilterInput(multiSelect: MultiSelect) {
    setTimeout(() => {
      multiSelect.filterInputChild.nativeElement.focus();
      if (multiSelect.filterValue === '---11') {
        if (multiSelect.inputId === 'flange') {
          this.hideAddFlange(multiSelect);
        } else {
          this.hideAddOring(multiSelect);
        }
      }
    }, 0);
  }

  addNewFlange(flangeGasketSelect: MultiSelect) {
    if (this.newFlangeText === '') {
      return;
    }

    const newFlange = {
      id: this.pressureCartOptions['flange-gasket'].length + 1,
      name: 'Other (' + this.newFlangeText + ')',
    };

    this.pressureCartOptions['flange-gasket'].splice(
      this.pressureCartOptions['flange-gasket'].length - 1,
      0,
      newFlange
    );
    this.pressureCartForm.controls['flange-gasket'].value.push(newFlange);

    const aux = this.pressureCartForm.controls['flange-gasket'].value;
    this.pressureCartForm.controls['flange-gasket'].setValue([]);

    this.newFlangeText = '';

    this.otherSelected = false;
    flangeGasketSelect.filterValue = '';
    this.flangeFilterValue = '';
    setTimeout(() => {
      this.pressureCartForm.controls['flange-gasket'].setValue(aux);
    }, 0);
  }

  addNewOring(oringSelect: MultiSelect) {
    if (this.newOringText === '') {
      return;
    }

    const newOring = {
      id: this.pressureCartOptions['o-ring-required'].length + 1,
      name: 'Other (' + this.newOringText + ')',
    };

    this.pressureCartOptions['o-ring-required'].splice(
      this.pressureCartOptions['o-ring-required'].length - 1,
      0,
      newOring
    );
    this.pressureCartForm.controls['o-ring-required'].value.push(newOring);

    const aux = this.pressureCartForm.controls['o-ring-required'].value;
    this.pressureCartForm.controls['o-ring-required'].setValue([]);

    this.newOringText = '';

    this.otherSelectedoRing = false;
    oringSelect.filterValue = '';
    this.oringFilterValue = '';
    setTimeout(() => {
      this.pressureCartForm.controls['o-ring-required'].setValue(aux);
    }, 0);
  }

  addingOtherValue(type: string) {
    switch (type) {
      case 'InteriorPrep': {
        if (this.newinteriorPrepText !== '') {
          this.pressureCartForm.controls['interior-prep'].value.name =
            'Other (' + this.newinteriorPrepText + ')';
        } else {
          this.pressureCartForm.controls['interior-prep'].value.name = 'Other';
        }

        break;
      }

      case 'OxygenContent': {
        if (this.newOxygenContentText !== '') {
          this.pressureCartForm.controls['oxygen-content'].value.name =
            'Other (' + this.newOxygenContentText + ')';
        } else {
          this.pressureCartForm.controls['oxygen-content'].value.name = 'Other';
        }

        break;
      }

      case 'NitrogenPSI': {
        if (this.newNitrogenPSIText !== '') {
          this.pressureCartForm.controls['nitrogen-psi'].value.name =
            'Other (' + this.newNitrogenPSIText + ')';
        } else {
          this.pressureCartForm.controls['nitrogen-psi'].value.name = 'Other';
        }

        break;
      }
    }
  }

  checkRadioOtherValue(
    eventValue: any,
    radioGroup: string,
    input: HTMLInputElement
  ) {
    if (!eventValue) {
      return;
    }

    switch (radioGroup) {
      case 'InteriorPrep': {
        this.addinginteriorPrep =
          eventValue.id ===
          this.pressureCartOptions['interior-prep'][
            this.pressureCartOptions['interior-prep'].length - 1
          ].id;
        break;
      }

      case 'OxygenContent': {
        this.addingOxygenContent =
          eventValue.id ===
          this.pressureCartOptions['oxygen-content'][
            this.pressureCartOptions['oxygen-content'].length - 1
          ].id;
        break;
      }

      case 'NitrogenPSI': {
        this.addingNitrogenPSI =
          eventValue.id ===
          this.pressureCartOptions['nitrogen-psi'][
            this.pressureCartOptions['nitrogen-psi'].length - 1
          ].id;
        break;
      }
    }

    setTimeout(() => {
      input.focus();
    }, 0);
  }

  addTextBreakline(name: string) {
    const splitSpace = name.split(' ');
    return splitSpace[0] + '<br>' + splitSpace[1];
  }

  next() {
    // TODO => you should submit the values by calling setQuoteRequest in the below line
    this.quoteRequest['mechanical-options']['pressure-tank'] =
      this.createSubmittedObj();
    this.quoteRequestService.setQuoteRequest(this.quoteRequest);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.LEASING_OPTIONS);
    this.draftQuoteService.saveDraftQuation(REQUEST_STEPS.LEASING_OPTIONS);
  }

  back() {
    this.quoteRequest['mechanical-options']['pressure-tank'] =
      this.createSubmittedObj();
    this.quoteRequestService.setQuoteRequest(this.quoteRequest);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.SELECTION);
  }

  private createOptionsArray(options: any, values: any) {
    if (values.length > options.length) {
      return values;
    }

    const array = options;
    const dif = values.filter((e: any) => {
      return !options.some((item: any) => item.id === e.id);
    });

    array.splice(array.length - 1, 0, ...dif);

    return array;
  }
}
